<template>
	<div>
		<p class="mb-3 mt-3 ml-5 g-table--description">{{ title }}</p>
		<div class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1">
			<vx-card :cardBorder="false" :noShadow="true" v-show-slide="featuresOpen">
				<div class="vx-row">
					<div class="vx-col md:w-1/2 w-full">
						<p class="mb-3">
							<code class="text-primary font-bold" v-text="$t('ManualData.InformationFound')"></code>
						</p>
						<div v-for="(value, key) in local_data.register" :key="key">
							<span class="g-label--normal">{{ key }}: </span>
							<span class="vs-table-text" v-text="value"></span>
							<feather-icon
								:title="titleDeleteProperty"
								v-if="editMode"
								icon="XIcon"
								svgClasses="w-5 h-5 hover:text-primary text-danger stroke-current"
								class="ml-2"
								@click.stop="removeProperties(key)"
							/>
							<feather-icon
								v-if="editMode"
								:title="titleUpdateProperty"
								icon="Edit2Icon"
								svgClasses="w-5 h-5 hover:text-primary text-success stroke-current"
								class="ml-2"
								@click.stop="editProperties(key, value)"
							/>
							<vs-divider class="d-theme-border-grey-light m-2" />
						</div>
					</div>
					<div class="vx-col md:w-1/2 w-full">
						<p class="mb-3">
							<code class="text-danger font-bold" v-text="$t('ManualData.ErrorsFound')"></code>
						</p>
						<div v-for="(value, index) in local_data.validator.error" :key="index">
							<span class="g-label--normal">{{ findErrorNamePropertyValidator(value) }}: </span>
							<span class="vs-table-text">{{ validateRequired(value) }}</span>
							<feather-icon
								v-if="editMode && value.validator === 'required'"
								:title="titleAddProperty"
								icon="PlusSquareIcon"
								svgClasses="w-5 h-5 hover:text-primary text-success stroke-current"
								class="ml-2"
								@click.stop="addProperty(findErrorNamePropertyValidator(value), index)"
							/>
							<vs-divider class="d-theme-border-grey-light m-2" />
						</div>
					</div>
				</div>
			</vx-card>
		</div>
		<vs-prompt
			:title="$t('Information')"
			@cancel="cancelPrompt"
			@accept="acceptPrompt"
			@close="closePrompt"
			:active.sync="activePrompt"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
		>
			<div class="con-exemple-prompt">
				<p class="vs-table-text">{{ $t("ManualData.EditAlertText") }}</p>
				<div class="mt-4">
					<!-- USERNAME -->
					<vx-input-group class="mb-base">
						<template slot="prepend">
							<div class="prepend-text bg-primary">
								<span class="vs-table-text">{{ propertySelected }}</span>
							</div>
						</template>
						<vs-input v-model.trim="propertyValue" />
					</vx-input-group>
					<!-- /USERNAME -->
				</div>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import moduleCommon from "@/store/common/moduleCommon.js";
import Commons from "@/helpers/commons.js";
import vSelect from "vue-select";

export default {
	props: {
		data: {
			type: Object,
		},
		category_name: {
			type: String,
		},
		roles: {
			type: Array,
			default: [],
		},
		edit: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		vSelect,
	},
	data() {
		return {
			featuresOpen: false,
			local_data: JSON.parse(JSON.stringify(this.data)),
			activePrompt: false,
			role_local_sel: {label: this.$t("Select"), value: null},
			roles_local: this.roles,
			propertySelected: "",
			propertyValue: "",
			editMode: false,
		};
	},
	computed: {
		titleAddProperty() {
			return this.$t("Add") + " " + this.$t("ManualData.Property");
		},
		titleUpdateProperty() {
			return this.$t("Crud.Update") + " " + this.$t("ManualData.Property");
		},
		titleDeleteProperty() {
			return this.$t("Crud.Delete") + " " + this.$t("ManualData.Property");
		},
		title() {
			return this.data.register.name ? this.data.register.name : this.data.added_on;
		},
		nameProperty() {
			return function (key) {
				let name = this.$t(`ManualData.${key}`);
				if (name.split(".").length > 1) {
					return name.split(".")[1];
				} else {
					return name;
				}
			};
		},
		processErrorValidator() {
			return function (cadena) {
				//var cadena = "'dane' is a required property";
				const expresion = /'(.*)'/gm;
				const foundMatch = cadena.match(expresion);
				return foundMatch ? foundMatch[0].replace(/'/g, "") : cadena;
			};
		},
		findErrorNamePropertyValidator() {
			return function validator(value) {
				if (Array.isArray(value)) {
					return validator(value[0]);
				}
				const absolute_path = value.absolute_path[0];
				if (absolute_path === "additional_info") {
					let message = value.message;
					const expresion = /'(.*)'/gm;
					const foundMatch = message.match(expresion);
					if (value.absolute_path.length > 1) {
						return value.absolute_path[1];
					}
					return foundMatch ? foundMatch[0].replace(/'/g, "") : message;
				} else {
					return absolute_path;
				}
			};
		},
		validateRequired() {
			const vali = (value) => {
				if (Array.isArray(value)) {
					return vali(value[0]);
				}
				switch (value.validator) {
					case "required":
						return this.messageValidator(value.message);
						break;
					case "backend":
						return this.messageValidator(value.message);
						break;
					case "minLength":
						return this.$t("ManualData.TooShortProperties");
						break;
					case "additionalProperties":
						return this.$t("ManualData.ValidatorAdditionalProperties");
						break;
					default:
						return value.message;
						break;
				}
			};
			return vali;
		},
		roleOptions() {
			const res = Commons.generateSelectOptios(this.roles_local, "alias", "id");
			return res === undefined || res === null || res.length === 0 ? [] : res;
		},
	},
	methods: {
		toggleFeatures() {
			this.featuresOpen = !this.featuresOpen;
		},
		changeEditMode() {
			this.editMode = !this.editMode;
			if (!this.featuresOpen) {
				this.featuresOpen = !this.featuresOpen;
			}
		},
		getData() {
			this.$emit("resolveManualDataEmit", this.local_data);
		},
		findText(searhStr, str) {
			if (str.search(searhStr) != -1) {
				return true;
			} else {
				return false;
			}
		},
		messageValidator(message) {
			if (this.findText("Already registered", message)) return this.$t("ManualData.AlreadyRegistered");
			else if (this.findText("Date less than current date", message))
				return this.$t("ManualData.DateLessThanCurrentDate");
			else if (this.findText("Not registered", message)) return this.$t("ManualData.NotRegistered");
			else if (this.findText("is a required property", message))
				return this.$t("ManualData.ValidatorRequiredProperty");
			else if (this.findText("Init hour greater than end hour", message)) return this.$t("Schedule.ValidEndOur");
			else if (this.findText("The address could not be georeferenced", message))
				return this.$t("ManualData.AddressCouldBeNotGeoreferenced");
			else if (this.findText("coordinates could not be found", message))
				return this.$t("ManualData.CoordinatesCouldBeNotFound");
			else if (this.findText("error_date", message)) return this.$t("ManualData.ErrorDate");
			else if (this.findText("error_init_hour", message)) return this.$t("ManualData.ErrorInitHour");
			else if (this.findText("error_end_hour", message)) return this.$t("ManualData.ErrorEndHour");
			else if (this.findText("Init hour less than current time", message))
				return this.$t("ManualData.InitHourLessThanCurrentTime");
			else if (this.findText("Duplicate record in excel", message))
				return this.$t("ManualData.DuplicateRecordInExcel");
			else if (this.findText("Dane code not found", message)) return this.$t("ManualData.DaneCodeNotFound");
			else if (this.findText("Save record error", message)) return this.$t("ManualData.SaveRecordError");
			else if (this.findText("Activity not available for the resource", message))
				return this.$t("Schedule.ActivityNoAvailable");
			else if (this.findText("Resource has no activities", message))
				return this.$t("ManualData.ResourceHasNoActivities");
			else if (this.findText("time data", message)) return this.$t("ManualData.TimeDataFormat");
			else return message;
		},
		addProperty(name, index) {
			this.local_data.validator.error.splice(index, 1);
			this.local_data.register[name] = "";
			this.propertySelected = name;
			this.activePrompt = true;
		},
		removeProperties(property) {
			delete this.local_data.register[property];
			const res = {...this.local_data.register};
			this.local_data.register = res;
		},
		editProperties(key, value) {
			this.propertySelected = key;
			this.propertyValue = value;
			this.activePrompt = true;
		},
		acceptPrompt() {
			this.local_data.register = {
				...this.local_data.register,
				[this.propertySelected]: this.propertyValue,
			};
		},
		cancelPrompt() {
			this.propertySelected = "";
			this.propertyValue = "";
		},
		closePrompt() {
			this.propertySelected = "";
			this.propertyValue = "";
		},
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
	},
};
</script>
